import {
  faAlarmClock,
  faAnglesUpDown,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowUp,
  faArrowUpRightFromSquare,
  faArrowsAlt,
  faArrowTurnRight,
  faArrowUpFromLine,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faFaceAwesome,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileXmark,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faHeading,
  faHighlighterLine,
  faHighlighter,
  faHourglassStart,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUsers,
  faVault,
  faXmark,
} from '@awesome.me/kit-da13514c94/icons/classic/regular'

export const regularLibrary = [
  faAlarmClock,
  faAnglesUpDown,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowUpRightFromSquare,
  faArrowUp,
  faArrowsAlt,
  faArrowTurnRight,
  faArrowUpFromLine,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faFaceAwesome,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileXmark,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faHeading,
  faHighlighterLine,
  faHighlighter,
  faHourglassStart,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUsers,
  faVault,
  faXmark,
]
